/* eslint-disable eqeqeq */
import { isCreatedByCurrentUser } from ".";
import { requestStatus } from "../../../../../constants";

export const getNextStep = (detail: any) => {
  if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
    return -1;
  }

  if (detail?.fields?.eApprovedStatus === requestStatus.submitted) {
    return 1;
  }

  if (detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted) {
    return 2;
  }

  if (detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted) {
    return 3;
  }

  if (detail?.fields?.eAssigneeStatus === requestStatus.submitted) {
    return 4;
  }

  return 5;
};

export const getRevokeStep = (detail: any, currentUserName: string) => {
  const nextStep = getNextStep(detail);

  if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
    return 0;
  }

  if (
    detail?.fields?.eApprovedBy === currentUserName &&
    nextStep === 2 &&
    detail?.fields?.eApprovedStatus === requestStatus.approved
  ) {
    return 1;
  }

  if (
    detail?.fields?.eApprovedByITLead === currentUserName &&
    nextStep === 3 &&
    detail?.fields?.eApprovedByITLeadStatus === requestStatus.approved
  ) {
    return 2;
  }

  if (
    detail?.fields?.eApprovedByITHead === currentUserName &&
    nextStep === 4 &&
    detail?.fields?.eApprovedByITHeadStatus === requestStatus.approved
  ) {
    return 3;
  }

  return 0;
};

export const isEnableRevoke = (detail: any, currentUserName: string) => {
  const currentStep = getRevokeStep(detail, currentUserName);

  if (currentStep === 1 && detail?.fields?.eApprovedBy === currentUserName) {
    return true;
  }

  if (currentStep === 2 && detail?.fields?.eApprovedByITLead === currentUserName) {
    return true;
  }

  if (currentStep === 3 && detail?.fields?.eApprovedByITHead === currentUserName) {
    return true;
  }

  return false;
};

export const isEnableAccept = (detail: any, currentUserName: string) => {
  currentUserName = currentUserName.toLowerCase();

  const nextStep = getNextStep(detail);

  if (detail?.fields?.eRequestStatus === requestStatus.rejected) {
    return false;
  }

  if (
    detail?.fields?.eApprovedBy === currentUserName &&
    nextStep === 1 &&
    detail?.fields?.eApprovedStatus === requestStatus.submitted
  ) {
    return true;
  }

  if (
    detail?.fields?.eApprovedByITLead === currentUserName &&
    nextStep === 2 &&
    detail?.fields?.eApprovedByITLeadStatus === requestStatus.submitted
  ) {
    return true;
  }

  if (
    detail?.fields?.eApprovedByITHead === currentUserName &&
    nextStep === 3 &&
    detail?.fields?.eApprovedByITHeadStatus === requestStatus.submitted
  ) {
    return true;
  }

  if (
    detail?.fields?.eAssignee === currentUserName &&
    nextStep === 4 &&
    detail?.fields?.eAssigneeStatus === requestStatus.submitted
  ) {
    return true;
  }

  return false;
};

export const isEnableEdit = (detail: any, currentUser: string) => {
  return isCreatedByCurrentUser(detail, currentUser) && getNextStep(detail) == 1;
};
